import React from 'react'
import { Status } from '../Status'
import { ComplianceStore } from '../ComplianceStore'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'

interface Props {
  logs: IInventoryLog[][]
  complianceStore: ComplianceStore
  ignoreableLogs: IInventoryLog[]
}

export const InventorylogAlert = React.memo((props: Props) => {
  const { logs, complianceStore, ignoreableLogs } = props

  return (
    <>
      <Status complianceStore={complianceStore} />
      <div className='alert alert-warning mt-3 warning-box'>
        <span className='fa fa-exclamation-triangle mr-2' />
        We found {logs.length} {logs.length > 1 ? 'products' : 'product'} that will show up in
        "other additions/reductions".
        <hr />
        If you know the reason for the inventory change, press "modify" for each row.
        <hr />
        If you don't know, leave the inventory change in the "other additions/reductions" columns.
      </div>
      {ignoreableLogs.length > 0 && (
        <div className='alert alert-success warning-box'>
          <span className='fa fa-exclamation-triangle mr-2' />
          {ignoreableLogs.length} products can be safely ignored.
        </div>
      )}
    </>
  )
})
